import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton";
import { VETTED_PLACES_WORLDWIDE } from "@/constants";

export const Statement = ({ onAnswer }) => {
    const [isExiting, setIsExiting] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [activeRegion, setActiveRegion] = useState(0);

    const regions = [
        { emoji: '🗽', count: '150k+', label: 'US Places' },
        { emoji: '🌎', count: `${VETTED_PLACES_WORLDWIDE}+`, label: 'Global Places' },
        { emoji: '🌆', count: '1k+', label: 'Cities' },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveRegion(current => (current + 1) % regions.length);
        }, 2000);

        setTimeout(() => setShowButton(true), 1000);
        return () => clearInterval(interval);
    }, []);

    const handleContinue = () => {
        setShowButton(false);
        setTimeout(() => {
            setIsExiting(true);
            setTimeout(() => onAnswer('continue'), 800);
        }, 400);
    };

    return (
        <div
            className={classNames(
                "relative h-full flex flex-col items-center justify-start px-6",
                "transition-all duration-500 ease-in-out",
                isExiting
                    ? "opacity-0 transform translate-y-10"
                    : "opacity-100 transform translate-y-0"
            )}
        >
            <div className="text-center space-y-4 max-w-[600px] mt-[48px]">
                <h2 className="text-[28px] md:text-[36px] leading-tight font-bold text-black">
                    The{' '}
                    <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                        largest
                    </span>{' '}
                    gluten-free map
                </h2>
            </div>

            <div className="flex-1 flex items-center justify-center w-full">
                <div className="space-y-6 w-full max-w-[400px]">
                    {regions.map((region, index) => (
                        <div
                            key={index}
                            className={classNames(
                                "flex flex-col items-center gap-2 p-6 rounded-xl transition-all duration-500",
                                activeRegion === index
                                    ? "bg-white shadow-lg scale-105"
                                    : "bg-gray-50"
                            )}
                        >
                            <div className="text-4xl mb-2">{region.emoji}</div>
                            <div className="text-2xl font-bold text-gray-800">
                                {region.count}
                            </div>
                            <div className="text-gray-600">
                                {region.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div
                className={classNames(
                    "fixed bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-white via-white to-transparent pb-6 pt-10",
                    "transition-all duration-500",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}
            >
                <PorangeButton
                    full={true}
                    className="h-[56px] rounded-[16px] text-lg shadow-md"
                    onClick={handleContinue}
                >
                    Continue
                </PorangeButton>
            </div>
        </div>
    );
};

export default Statement; 